
// 递归判断数组或对象是否有文件对象
function hasFile(obj: any): boolean {
  if (Array.isArray(obj)) {
    return obj.some((item) => hasFile(item));
  }
  if (obj instanceof File) {
    return true;
  }
  if (obj instanceof Blob) {
    return true;
  }
  // null和undefined不是对象，所以要排除
  if (obj === null || obj === undefined) {
    return false
  }
  if (typeof obj === 'object') {
    let isFile = false;
    try {
      isFile = Object.values(obj)?.some((item) => hasFile(item))
    } catch (error) {
      isFile = false;
    }
    return isFile;
  }
  return false;
}


// 对promise请求的throttling
const allPromiseCache = new WeakMap();

// TS推导throttlingPromise的返回类型和原本函数的返回类型一致

type ThrottlingPromise = <T extends (...args: any[]) => Promise<any>>(fn: T) => (...args: Parameters<T>) => ReturnType<T>;

const throttlingPromise: ThrottlingPromise = function (fn) {
  let promiseCache = allPromiseCache.get(fn);
  if (!promiseCache) {
    promiseCache = new Map();
    allPromiseCache.set(fn, promiseCache);
  }
  return function (...args) {
    // 判断如果参数中有文件对象，不做缓存
    if (hasFile(args)) {
      return fn(...args);
    }
    const key = JSON.stringify(args);
    if (promiseCache.has(key)) {
      return promiseCache.get(key);
    }
    const promise = Promise.resolve(fn(...args))
    promise.finally(() => {
      promiseCache.delete(key);
    });
    promiseCache.set(key, promise);
    return promise;
  };
}

export default throttlingPromise;
